import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import { getMatchOption } from '../../shared/selectFn';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ComList from '../ComList';

const monthFormat = "YYYY-MM";

class UpdateClinicalTrialExp extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        const { ...params } = record || {};
        const { investigationAreaId, investigationProductStageIds, investigationProduct: oldProduct, secondInvestigationProduct } = params;
        params.investigationProductStage = investigationProductStageIds ? investigationProductStageIds.split(',') : '';
        params.investigationProduct = secondInvestigationProduct ? [oldProduct, secondInvestigationProduct] : (oldProduct ? [oldProduct] : undefined);
        this.setState({
            params,
            visible: true,
            isEdit: !!record,
        }, () => {
            this.loadAreaList();
            investigationAreaId && this.loadDiseaseList(investigationAreaId);
            this.queryVitaeList('CLINICAL_EXPERIENCE');
            this.queryVitaeList('INVESTIGATION_TYPE');
            this.queryVitaeList('INVESTIGATION_PRODUCT');
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            areaOptions: [],
            diseaseOptions: [],
            roleOptions: [],
            typeOptions: [],
            medicineTypeOptions: [],
            stageOptions: [],
        });
    }

    queryVitaeList = (typeName) => {
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaeList,
            data: {typeName},
            dataType: 'json',
            doneResult: res => {
                const { vitaeList = [] } = res;
                const options = vitaeList.map(item => {
                    const { vitaeDictId, chName, enName, childList } = item;
                    return {
                        zh: chName,
                        en: enName,
                        value: vitaeDictId,
                        child: childList,
                    };
                });
                if (typeName === 'CLINICAL_EXPERIENCE') {
                    this.setState({ roleOptions: options });
                } else if (typeName === 'INVESTIGATION_TYPE') {
                    this.setState({ typeOptions: options });
                } else if (typeName === 'INVESTIGATION_PRODUCT') {
                    options.map(data => {
                        if (data.value == 199) {
                            data.children = data.child.map(childData => ({
                                label: childData.chName,
                                value: childData.vitaeDictId,
                            }));
                        }
                    })
                    this.setState({ medicineTypeOptions: options }, () => {
                        const { params: { investigationProduct = [] } } = this.state;
                        investigationProduct[0] && this.setStageOptions(investigationProduct);
                    });
                }
            }
        };
        $.sendRequest(options);
    }

    loadAreaList = () => {
        const options = {
            method: 'POST',
            url: API_URL.common.queryAllInvestigationArea,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const areaOptions = (res.data || []).map(item => {
                    const { englishName, investigationAreaId, investigationAreaName } = item;
                    return {
                        zh: investigationAreaName,
                        en: englishName,
                        value: investigationAreaId,
                    };
                });
                this.setState({ areaOptions });
            }
        };
        $.sendRequest(options);
    }

    loadDiseaseList = (investigationAreaId) => {
        const options = {
            method: 'POST',
            url: API_URL.common.queryAllDisease,
            data: { investigationAreaId },
            dataType: 'json',
            doneResult: res => {
                const diseaseOptions = (res.data || []).map(item => {
                    const { diseaseId, diseaseName, englishName } = item;
                    return {
                        value: diseaseId,
                        zh: diseaseName,
                        en: englishName,
                    };
                });
                this.setState({ diseaseOptions });
            }
        };
        $.sendRequest(options);
    }

    getRenderList = () => {
        const { isChinese } = this.props;
        const {
            params,
            areaOptions = [],
            diseaseOptions = [],
            roleOptions = [],
            typeOptions = [],
            medicineTypeOptions = [],
            stageOptions = [],
        } = this.state;
        const { investigationAreaId, investigationProduct = [], investigationProductStage } = params;
        areaOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        diseaseOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        roleOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        typeOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        medicineTypeOptions.forEach(i => i.label = isChinese ? i.zh : i.en);
        // 没选阶段时，单独判断；选择一个时，判断是否是多选项；选择两个以上，默认可多选
        let multiplable = true;
        let showStageOther = false;
        if ((investigationProductStage || []).length === 1) {
            const { isMultipleChoice, chName } = getMatchOption(stageOptions, 'value', investigationProductStage[0]);
            multiplable = isMultipleChoice == 1;
            showStageOther = chName === '其他';
        }
        stageOptions.forEach(i => {
            i.name = isChinese ? i.zh : i.en;
            i.disabled = (investigationProductStage || []).length ? multiplable ? i.isMultipleChoice == null : i.isMultipleChoice == 1 : false;
        });
        const renderList = [{
            zh: '项目领域',
            en: 'Therapeutic Area',
            key: 'investigationAreaId',
            require: true,
            option: {
                type: 'select',
                allowClear: false,
                disabled: !isChinese,
                list: areaOptions,
                style: { width: 272 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            }
        }, {
            zh: '疾病',
            en: 'Therapeutic Area',
            key: 'diseaseId',
            require: true,
            option: {
                type: 'select',
                allowClear: false,
                disabled: !isChinese || !investigationAreaId,
                list: diseaseOptions,
                style: { width: 272 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            }
        }, {
            key: isChinese ? 'diseaseRemarkChinese' : 'diseaseRemarkEnglish',
            require: true,
            colon: false,
            option: {
                type: 'input',
                style: { width: 272 },
                placeholder: isChinese ? '补充其他说明' : 'Please supply other instructions',
            },
            display: {
                symbol: 'eq',
                key: 'diseaseId',
                toName: true,
                value: isChinese ? '其他' : 'Others',
            },
        }, {
            zh: '项目角色',
            en: 'Role',
            key: 'clinicalRoleId',
            require: true,
            option: {
                type: 'select',
                allowClear: false,
                disabled: !isChinese,
                list: roleOptions,
                style: { width: 272 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            }
        }, {
            key: isChinese ? 'clinicalRoleCommentsChinese' : 'clinicalRoleCommentsEnglish',
            require: true,
            colon: false,
            option: {
                type: 'input',
                style: { width: 272 },
                placeholder: isChinese ? '补充其他说明' : 'Please supply other instructions',
            },
            display: {
                symbol: 'eq',
                key: 'clinicalRoleId',
                toName: true,
                value: isChinese ? '其他' : 'Other',
            },
        }, {
            zh: '项目类型',
            en: 'Study Type',
            key: 'clinicalTypeId',
            require: true,
            option: {
                type: 'select',
                allowClear: false,
                disabled: !isChinese,
                list: typeOptions,
                style: { width: 272 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            }
        }, [{
                zh: '参与时间',
                en: 'Time',
                key: 'clinicalStartTime',
                require: true,
                option: {
                    type: 'monthPicker',
                    allowClear: false,
                    disabled: !isChinese,
                    format: monthFormat,
                    style: { width: 120 },
                    placeholder: isChinese ? '请选择' : 'Please select ',
                },
                attr: {
                    right: { width: 120 }
                },
            }, {
                zh: '到',
                en: 'To',
                key: 'clinicalEndTime',
                colon: true,
                option: {
                    type: 'monthPicker',
                    allowClear: false,
                    disabled: !isChinese,
                    format: monthFormat,
                    style: { width: 120 },
                    placeholder: isChinese ? '不填写代表至今' : "Present",
                },
                attr: {
                    left: { width: 32, padding: '0 10px' },
                    right: { width: 120 },
                },
            }
        ], {
            zh: '研究产品类型',
            en: 'Investigational Product Type',
            key: 'investigationProduct',
            require: true,
            option: {
                type: 'cascader',
                allowClear: false,
                disabled: !isChinese,
                list: medicineTypeOptions,
                style: { width: 272 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            }
        }, {
            zh: '项目分期',
            en: 'Study Phase',
            key: 'investigationProductStage',
            require: true,
            option: {
                type: 'select',
                mode: 'multiple',
                disabled: !isChinese || !investigationProduct[0],
                style: { width: 272 },
                list: stageOptions,
                placeholder: isChinese ? '请选择(可多选)' : 'Please select(Multiple choice) ',
            }
        }];
        if (showStageOther) {
            renderList.push({
                key: isChinese ? 'investigationProductStageRemarkChinese' : 'investigationProductStageRemarkEnglish',
                require: true,
                colon: false,
                option: {
                    type: 'input',
                    style: { width: 272 },
                    placeholder: isChinese ? '补充其他说明' : 'Please supply other instructions',
                }
            });
        }
        const setName = (item) => {
            if (isChinese) {
                item.name = item.zh;
            } else {
                item.name = item.en;
            }
        };
        const loopArr = (arr) => {
            if (Array.isArray(arr)) {
                arr.forEach(item => loopArr(item));
            } else {
                setName(arr);
            }
        };
        loopArr(renderList);
        this.renderList = renderList;
    }

    checkValue = param => {
        const { params } = this.state;
        const { name, key, require, option, warning, display } = param;
        const { placeholder } = option;
        
        let noError = true;
        if (require) {
            if ((!params[key] || (Array.isArray(params[key]) && params[key].length == 0)) && !display) {
                message.warning(`${placeholder}${warning || name || ''}`);
                noError = false;
            } else {
                if (display) {
                    const { symbol, key, value = null } = display;
                    if (symbol === 'eq') {
                        if (value) {
                            const list = this.renderList || [];
                            const tar = list.find(i => i.key === key);
                            const arr = tar.option.list || [];
                            const o = arr.find(a => a.value == params[key]);
                            if (o && o.name === value && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        } else {
                            if (params[key] && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        }
                    }
                }
            }
        }
        return noError;
    }

    submit = () => {
        const {
            isEdit,
            params,
            params: {
                clinicalStartTime,
                clinicalEndTime,
                investigationProductStage,
                investigationProduct = [],
            }
        } = this.state;
        const { userId } = this.props;
        this.getRenderList();
        const renderList = this.renderList || [];
        const hasError = renderList.every(item => {
            if (Array.isArray(item)) {
                return item.every(i => this.checkValue(i));
            } else {
                return this.checkValue(item);
            }
        });
        if (!hasError) {
            return;
        }

        let url;
        params.investigationProductStage = investigationProductStage ? investigationProductStage.join(',') : undefined;
        if (isEdit) {
            params.clinicalStartTime = clinicalStartTime ? clinicalStartTime.slice(0, 7) : clinicalStartTime;
            params.clinicalEndTime = clinicalEndTime ? clinicalEndTime.slice(0, 7) : clinicalEndTime;
            url = API_URL.personal.modifyVitaeClinicalExperience;
        } else {
            url = API_URL.personal.addVitaeClinicalExperience;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: {
                userId,
                ...params,
                investigationProduct: investigationProduct[0],
                secondInvestigationProduct: investigationProduct[1],
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    setStageOptions = (value = []) => {
        const { medicineTypeOptions } = this.state;
        const option = medicineTypeOptions.find(i => i.value == value[0]);
        const { child = [] } = option || {};
        let stageOptions = [];
        if (value.length > 1) {
            let childList = [];
            child.map(el => {
                if (el.vitaeDictId == value[1]) {
                    childList = el.childList;
                }
            })
            stageOptions = childList.map(i => ({
                value: i.vitaeDictId,
                zh: i.chName,
                en: i.enName,
                ...i,
            }));
        } else {
            stageOptions = child.map(i => ({
                value: i.vitaeDictId,
                zh: i.chName,
                en: i.enName,
                ...i,
            }));
        }
        this.setState({ stageOptions });
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;

        if (key === 'investigationAreaId') {
            params.diseaseId = undefined;
            this.loadDiseaseList(value);
        }
        if (key === 'diseaseId') {
            params.diseaseRemarkChinese = '';
            params.diseaseRemarkEnglish = '';
        }
        if (key === 'clinicalRoleId') {
            params.clinicalRoleCommentsChinese = '';
            params.clinicalRoleCommentsEnglish = '';
        }
        if (key === 'investigationProduct') {
            params.investigationProductStage = [];
            this.setStageOptions(value);
        }
        if (key === 'investigationProductStage') {
            const { stageOptions } = this.state;
            const { isMultipleChoice, value: investigationByStageId } = getMatchOption(stageOptions, 'value', (value || []).slice(-1));
            params.investigationProductStage = isMultipleChoice == 1 ? value : investigationByStageId ? [String(investigationByStageId)] : [];
            params.investigationProductStageRemarkChinese = '';
            params.investigationProductStageRemarkEnglish = '';
        }
        this.setState({ params });
    }

    render() {
        const { isEdit, visible, loading, params } = this.state;
        this.getRenderList();
        const list = this.renderList || [];
        return (
            <Modal
                title={`${isEdit ? '修改' : '新增'}临床试验经验`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal EditPersonModal"
                confirmLoading={loading}
                maskClosable={false}
                width="540px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ComList
                            list={list}
                            params={params}
                            onChange={(value, key) => this.handleChange(value, key)}
                        />
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateClinicalTrialExp;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/UpdateClinicalTrialExp.js